import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/element-plus.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'
import permissionDirective from './directives/permission'
import { formatDateTime } from '@/utils/dateFormat'
import installFlowUi from './plugins/guns.js'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.use(installFlowUi)
app.directive('permission', permissionDirective)

// 注册全局时间格式化方法
app.config.globalProperties.$formatDateTime = formatDateTime

app.mount('#app')
